import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SpeakerOffFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 2.53v11.323c0 .3-.1.5-.3.701L5.8 31.888c-.2.2-.4.3-.7.3H1c-.5 0-1-.4-1-1.001V13.753c0-.501.4-1.002 1-1.002h7.5L21.9 1.729c.3-.2.7-.3 1-.1.4.2.6.5.6.902ZM44 22.47c0 8.917-6.7 16.332-15.3 17.334-.5.1-1-.301-1.1-.902-.1-.501.3-1.002.9-1.102 7.6-.902 13.5-7.415 13.5-15.33 0-5.11-2.4-9.62-6.2-12.425l-4 4.008c2.8 1.804 4.7 4.91 4.7 8.417 0 4.709-3.3 8.717-7.7 9.719-.5.1-1.1-.2-1.2-.702-.1-.5.2-1.102.7-1.202 3.5-.802 6.2-4.008 6.2-7.815 0-3.006-1.7-5.611-4.1-7.014l-6.8 6.813v20.04c0 .4-.2.7-.6.901-.3.2-.8.1-1-.1l-10.6-8.617-6.1 6.112c-.4.401-1 .401-1.4 0a.97.97 0 0 1 0-1.403l35-35.068c.4-.401 1-.401 1.4 0 .4.4.4 1.002 0 1.402l-3 3.006c4 3.307 6.7 8.317 6.7 13.928Z"
  }));
});
SpeakerOffFill.displayName = 'SpeakerOffFill';
SpeakerOffFill.defaultProps = {
  'aria-label': 'SpeakerOffFill'
};
export default SpeakerOffFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SpeakerOffFill.js
// module id = 3286
// module chunks = 11